/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Success_TitleInputs */

const tr_contact_form_success_title = /** @type {(inputs: Contact_Form_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesajın ulaştı 🎉`)
};

const en_contact_form_success_title = /** @type {(inputs: Contact_Form_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message received 🎉`)
};

const de_contact_form_success_title = /** @type {(inputs: Contact_Form_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Nachricht ist angekommen 🎉`)
};

const ru_contact_form_success_title = /** @type {(inputs: Contact_Form_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваше сообщение доставлено 🎉`)
};

/**
* | output |
* | --- |
* | "Message received 🎉" |
*
* @param {Contact_Form_Success_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_success_title = /** @type {((inputs?: Contact_Form_Success_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Success_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_success_title(inputs)
	if (locale === "de") return de_contact_form_success_title(inputs)
	if (locale === "ru") return ru_contact_form_success_title(inputs)
	return tr_contact_form_success_title(inputs)
});